import { RootState } from '@store/rootReducer'

export const selectImageElements = (state: RootState) => state.editor.imageElements.imageElements

export const selectFilterPacks = (state: RootState) => state.editor.imageElements.filterPacks
